module.exports = __webpack_public_path__ + "static/media/clipboard.0cd5ca47.svg";